import useSWR from 'swr';
import { CalendarService, DayOccupancyData } from '../../../api';

const MIN_REFRESH_MS = 30000;
const MAX_REFRESH_MS = 60000;

/**
 * One call renders the whole screen. Unlike the other calendar hooks this one is keyed on a single
 * date rather than a range, so it uses SWR directly instead of `useItems`.
 *
 * Polling is staggered per mount the way the other calendar hooks do it, and SWR's default
 * focus revalidation covers the "refetch when the admin comes back to the tab" requirement.
 */
const randomRefreshInterval = () => MIN_REFRESH_MS + Math.floor(Math.random() * (MAX_REFRESH_MS - MIN_REFRESH_MS));

const fetcher = async ({ date }: { date: string }): Promise<DayOccupancyData> =>
  CalendarService.getCalendarAreaOccupancy(date);

export const useAreaOccupancy = ({ date, enabled = true }: { date: string; enabled?: boolean }) => {
  const { data, error, isLoading, mutate } = useSWR(
    enabled ? { date, opId: 'getCalendarAreaOccupancy' } : null,
    fetcher,
    { refreshInterval: randomRefreshInterval(), keepPreviousData: true },
  );

  return {
    occupancy: data,
    isLoading,
    isError: error,
    reFetch: () => mutate(),
  };
};
